import { ShowDataFor } from 'utils/components/ShowDataFor/ShowDataFor';

export type CandlestickTileView = 'chart' | 'values';

export interface CandlestickTileConfigState {
    symbol?: string;
    bucketSize: number;
    showDataFor?: ShowDataFor;
    view: CandlestickTileView;
}

export const initialCandlestickTileConfigState: CandlestickTileConfigState = {
    bucketSize: 5,
    showDataFor: ShowDataFor.LastHour,
    view: 'chart',
};
